module.exports = __webpack_public_path__ + "img/Room5_017.09d4c474.svg";